// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KYyM","toggleWrap":"styles_toggleWrap__2y5i-","content":"styles_content__2WeHK","selectAreaCode":"styles_selectAreaCode__2EjoW"};